import { configure, defineRule } from 'vee-validate'
import { all } from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'
import ja from '~/src/js/locales/vee-validate/ja.json'

// @see https://vee-validate.logaretm.com/v4/guide/overview/
export const setUpVeeValidate = () => {
  defineRules()

  // 日本語メッセージの定義は '~/src/js/locales/vee-validate/ja.json' に記述する
  // 設定方法：https://vee-validate.logaretm.com/v4/guide/i18n
  setLocale('ja')
  configure({ generateMessage: localize({ ja }) })
}

const defineRules = () => {
  // @vee-validate/rules の全てのルールを読み込む
  Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule)
  })

  // Custom Global Rules
  // @vee-validate/rules に含まれないグローバルルールをこれ以下に定義する
  // 局所的にしか利用しないものは各コンポーネントで定義すること
  defineRule('zipcode', value => {
    return !value || value.length === 0 || /^[0-9]*$/.test(String(value))
  })
  defineRule('phone_length', value => {
    return !value || value.length === 0 || /\d{10,11}$/.test(String(value))
  })
  defineRule('katakana_name', value => {
    const pattern = /^[\u30A0-\u30FF\uFF65-\uFF9F]+$/ // 半角・全角カタカナ
    return (
      !value ||
      value.length === 0 ||
      pattern.test(String(value.replace(/\s+/g, ''))) // 空白を除去
    )
  })
}
